import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { METRICS } from '@root/joinroot.com/src/components/covid-driving';
import { toRgba } from '@root/joinroot.com/src/utils/colors';

export default function MetricControls({
  metric,
  setMetric,
  trackClick,
}) {
  const METRICS_TO_BUTTON_TEXT = {
    [METRICS.TRIP_MILES]: 'Miles driven',
    [METRICS.TRIP_COUNT]: 'Trips taken',
    [METRICS.TRIP_MINUTES]: 'Time spent driving',
  };

  const handleMetricChange = (event) => {
    trackClick('METRIC_CHANGED');
    setMetric(event.target.id);
    event.target.blur();
  };

  return (
    <div css={styles.splitButtonsContainer}>
      {Object.entries(METRICS_TO_BUTTON_TEXT).map(([metricName, buttonText], i) => {
        const isActive = metric === metricName;

        return (
          <button
            css={[styles.splitButton, isActive && styles.buttonIsActive]}
            id={metricName}
            key={i}
            onClick={(e) => handleMetricChange(e)}
          >
            {buttonText}
          </button>
        );
      })}
    </div>
  );
}

MetricControls.propTypes = {
  metric: PropTypes.string,
  setMetric: PropTypes.func,
  trackClick: PropTypes.func,
};

const zEase = 'cubic-bezier(0.165, 0.84, 0.44, 1)';

const styles = StyleSheet.create({
  splitButtonsContainer: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: Colors.gray40(),
    borderRadius: 6,
    boxShadow: `0 0 0 1px ${Colors.gray40()}`,
    '& > button + button': {
      marginLeft: 1,
    },
    '& > button:first-of-type': {
      borderRadius: '6px 1px 1px 6px',
    },
    '& > button:last-of-type': {
      borderRadius: '1px 6px 6px 1px',
    },
    ...Responsive.lessThanMd({
      width: '100%',
    }),
  },
  splitButton: {
    flexGrow: 1,
    position: 'relative',
    zIndex: 1,
    height: '100%',
    padding: '10px 18px',
    appearance: 'none',
    backgroundColor: Colors.white(),
    border: 'none',
    borderRadius: 1,
    color: Colors.gray60(),
    cursor: 'pointer',
    fontSize: 15,
    fontWeight: 'bold',
    lineHeight: '100%',
    transition: `300ms ${zEase}`,
    '&:focus': {
      zIndex: 2,
      outline: 'none',
      boxShadow: `0 0 0 1px ${Colors.rootOrange()}, 0 0 0 7px ${toRgba(Colors.rootOrange(), 0.25)}`,
    },
    '&:focus:not(.focus-visible)': {
      boxShadow: `0 0 0 1px ${Colors.rootOrange()}`,
    },
    ...Responsive.sm({
      fontSize: 16,
    }),
  },
  buttonIsActive: {
    backgroundColor: Colors.rootOrange(),
    color: Colors.white(),
    boxShadow: `0 0 0 1px ${Colors.rootOrange()}`,
  },
});
